// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__kbZxL","desabilitar":"OptionSelect_desabilitar__qfpFH","focado":"OptionSelect_focado__e7Z1d","novo":"OptionSelect_novo__mYXpY"};